import { useContext } from 'react';

import { OrderContext } from '../OrderProvider';
import type { OrderContextValue, OrderState } from '../types/Order.types';

export function useOrderContext(): OrderContextValue {
  const ctx = useContext(OrderContext);
  if (!ctx) throw new Error('useOrderContext must be used within OrderProvider');
  return ctx;
}

export type { OrderContextValue, OrderState };
